<template>
  <div class="pt-2 px-2 pb-6">
    <premium-section feature="selection">
      <div class="small text-medium-emphasis text-center line-height-normal px-2 mb-2" style="cursor: default">
        <v-icon size="small" class="mr-1" style="top: -1px">far fa-info-circle</v-icon>{{ $t('SELECTION.HELP') }}
      </div>
      <!-- SELECTION -->
      <div class="rounded px-2 py-1" style="border: 2px dashed #7DD467">
        <div class="text-center pointer" @click="hideSelectionElements = ! hideSelectionElements">
          <div class="d-inline position-relative">
            <b>{{ $t('SELECTION.COUNT_SELECTED', { count: selectionCount }) }}</b>
            <div class="d-flex align-center" style="position: absolute; top: 1px; bottom: 0; left: 100%">
              <v-icon v-if="hideSelectionElements" size="small" class="ml-1">far fa-angle-right</v-icon>
            </div>
          </div>
        </div>
        <v-expand-transition>
          <div v-if="! hideSelectionElements" class="mt-2">
            <v-row dense class="milestones-inline">
              <transition-group name="list-fade">
                <v-col v-for="el in selectedElements" :key="el.id" :cols="4" class="list-fade-item hovervisible-activator">
                  <planning-element-view :el="el" :show-details-items="[]" disable-mini-element disable-styling style="cursor: default; position: relative">
                    <div class="element-menu flex-center-center hovervisible-item" style="left: 0; width: 100%; z-index: 1;">
                      <v-btn icon variant="outlined" size="x-small" color="errorred" @click.stop="removeElement(el)">
                        <v-icon>far fa-times</v-icon>
                      </v-btn>
                    </div>
                  </planning-element-view>
                </v-col>
              </transition-group>
            </v-row>
            <div class="py-3 px-1">
              <select-element v-model="newTargets" :items="otherElements" multiple @update:model-value="addNewElement()"></select-element>
            </div>
          </div>
        </v-expand-transition>
      </div>

      <!-- OPERATIONS -->
      <selection-operation :planning="planning" @hide-selection-elements="hideSelectionElements = true"></selection-operation>
    </premium-section>
  </div>
</template>

<script>
  import useSelectionStore from '@/stores/selection';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import PlanningElementView from '@/components/Planning/PlanningElementView.vue';
  import SelectElement from '@/components/Reusables/SelectElement.vue';
  import SelectionOperation from '@/components/Selection/SelectionOperation.vue';

  export default {
    components: {
      PlanningElementView,
      SelectElement,
      SelectionOperation,
    },
    props: {
      planning: { type: Object, required: true },
    },
    data() {
      return {
        newTargets: null,
        hideSelectionElements: false,
        selectionStore: useSelectionStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      selectionCount() {
        return this.selectionStore.selectionCount;
      },
      selectedElements() {
        const elIds = this.selectionStore.selection;
        const selectedElementsById = new Map();
        this.planning.elements.forEach((el) => { if (elIds.has(el.id)) selectedElementsById.set(el.id, el); });
        return [...elIds].map(id => selectedElementsById.get(id)); // keep selection order
      },
      otherElements() {
        const elIds = this.selectionStore.selection;
        return this.planning.elements.filter(el => ! elIds.has(el.id));
      },
    },
    methods: {
      addNewElement() {
        if (! this.newTargets?.length) return;
        this.newTargets.forEach((target) => { this.selectionStore.selection.add(target.id); });
        this.newTargets = null;
      },
      removeElement(el) {
        this.selectionStore.selection.delete(el.id);
      },
    },
  };
</script>
